module.exports = __webpack_public_path__ + "img/svg.8d74f378.svg";